import { EventsRouteName } from './events';
import { ContactsRouteName } from './contacts';
import { FormsRouteName } from './forms';
import { NgoRouteName } from './ngo';
import { PaymentRouteName } from './payment';
import { ProgramsRouteName } from './program';
import { SystemRouteName } from './system';
import { JobRouteName } from './job';

enum RouteName {
	home = 'Home',
	profile = 'Profile',
	changePassword = 'ChangePassword',
	onboarding = 'Onboarding',
	signup = 'Signup',
	signupBasic = 'SignupBasic',
	signupEmail = 'SignupEmail',
	signupExtra = 'SignupExtra',
	login = 'Login',
	forgetPassword = 'ForgetPassword',
	staffWelcome = 'StaffWelcome',
	resetPassword = 'ResetPassword',
	resetPasswordSuccess = 'ResetPasswordSuccess',
	jobApplicationConsent = 'JobApplicationConsent',
	jobApplicationConsentTerms = 'JobApplicationConsentTerms',
	proposalEndorsement = 'ProposalEndorsement',
	requestFile = 'RequestFile',
	myProgramItems = 'MyProgramItems',
	inbox = 'Inbox',
	notificationSettings = 'NotificationSettings',
}

export {
	EventsRouteName,
	ContactsRouteName,
	FormsRouteName,
	NgoRouteName,
	PaymentRouteName,
	ProgramsRouteName,
	SystemRouteName,
	JobRouteName,
	RouteName,
};
